"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { X, Sparkles } from "lucide-react";
import { useTranslation } from "@/lib/hooks/useTranslation";
export function BetaBanner() {
  const $ = _c(10);
  const {
    locale
  } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);
  const [isHydrated, setIsHydrated] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsHydrated(true);
      const dismissed = localStorage.getItem("velyq-beta-banner-dismissed");
      if (dismissed === "true") {
        setIsVisible(false);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsVisible(false);
      localStorage.setItem("velyq-beta-banner-dismissed", "true");
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleDismiss = t2;
  if (!isHydrated || !isVisible) {
    return null;
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Sparkles className="h-4 w-4" />;
    t4 = <span className="font-medium">Beta</span>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  const t5 = locale === "fr" ? "\u2014 Velyq est en d\xE9veloppement. Ton feedback nous aide \xE0 am\xE9liorer l'app !" : "\u2014 Velyq is in development. Your feedback helps us improve!";
  let t6;
  if ($[5] !== t5) {
    t6 = <div className="flex items-center gap-2 text-sm">{t3}{t4}<span className="hidden sm:inline">{t5}</span></div>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <button onClick={handleDismiss} className="shrink-0 rounded-full p-1 hover:bg-white/20 transition-colors" aria-label="Dismiss"><X className="h-4 w-4" /></button>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6) {
    t8 = <div className="bg-gradient-to-r from-primary/90 to-primary text-primary-foreground"><div className="container mx-auto flex items-center justify-between gap-4 px-4 py-2">{t6}{t7}</div></div>;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
}